/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const padlock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.667 6.6V4.267a3.267 3.267 0 1 1 6.533 0V6.6M7.933 9.867v1.866M3.733 6.6h8.4c.516 0 .934.418.934.933v6.534a.933.933 0 0 1-.934.933h-8.4a.933.933 0 0 1-.933-.933V7.533c0-.515.418-.933.933-.933Z"
    />
  </svg>
)
export default padlock
